// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mc-0";
export var fileList = "_mc-2";
export var removeFileButton = "_mc-1";